module.exports = __webpack_public_path__ + "static/img/p_vip.47872bee.png";